import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import PubSub from 'services/pubsub-service';
import * as PubSubActionType from 'services/constants';

import { AppSettings } from '../../constants';
import * as UserActionType from '../constants';
import { ChangePasswordModal } from '../Components/change-password-modal';
import InputEditAble from '../../components/inputEditAble';
import PhoneNumberInput from 'components/PhoneNumberInput';
import '../my-profile.scss';
import HomeownerMyAccount from './homeowner-my-account';

class MyProfile extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    UserProfile: PropTypes.object,
    IsOpenFormChangePassword: PropTypes.bool,
    ErrorMsg: PropTypes.array
  }
  constructor(props) {
    super(props);
    this.state = {
      isOpenModal: false,
      firstName: this.props.UserProfile.firstName,
      lastName: this.props.UserProfile.lastName,
      phoneNumber: this.props.UserProfile.phoneNumber,
      daytimePhoneNumber: this.props.UserProfile.daytimePhoneNumber,
      email: this.props.UserProfile.email
    };
  }

  componentDidMount() {
    // this.props.dispatch({
    //   type: UserActionType.GET_USER_BY_USERID_ASYNC,
    //   params: localStorage[AppSettings.S1_UID]
    // });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.UserProfile) {
      this.setState({
        firstName: nextProps.UserProfile.firstName,
        lastName: nextProps.UserProfile.lastName,
        phoneNumber: nextProps.UserProfile.phoneNumber,
        daytimePhoneNumber: nextProps.UserProfile.daytimePhoneNumber,
        email: nextProps.UserProfile.email
      });
    }
  }

  onChangeInput = (type, e) => {
    this.setState({
      [type]: e.target.value
    });
  }

  onEdit = field => () => {
    this.setState({
      isEdit: {
        [field]: true
      }
    });
  }

  onSubmit = (params) => {
    if (!isEmpty(params)) {
      let values = {};
      values['userId'] = this.props.UserProfile.userId;
      values['email'] = this.props.UserProfile.email;
      values['firstName'] = this.props.UserProfile.firstName;
      values['lastName'] = this.props.UserProfile.lastName;
      values['phoneNumber'] = this.props.UserProfile.phoneNumber;
      values['daytimePhoneNumber'] = this.props.UserProfile.daytimePhoneNumber;
      values['roleName'] = this.props.UserProfile.roleName;

      this.props.dispatch({
        type: UserActionType.UPDATE_MY_PROFILE_ASYNC,
        params: {...values, ...params},
        callback: (data) => {
          if (data.error) {
            this.setState({ errorEmail: data.error });
          } else {
            if (params.email && params.email !== values['email']) {
              PubSub.publish(PubSubActionType.HOMEOWNER_CHANGE_EMAIL, {});
            }
            this.setState({ errorEmail: null });
          }
        }
      });
    }
  }

  onChangePasword = (e, data, callback) => {
    this.props.dispatch({
      type: UserActionType.CHANGE_PASSWORD_ASYNC,
      params: data,
      callback: (status, res) => {
        if (status === false) {
          callback(false, res);
        } else {
          this.toggleModal();
        }
      }
    });

  }

  toggleModal = () => {
    this.setState({ isOpenModal: !this.state.isOpenModal});
  }

  render() {
    return AppSettings.clientTypeValue === "Homeowner" ? (
      <HomeownerMyAccount />
    ) : (<div id='manage-my-profile'>
      <div className='page-title clearfix'>
        <h2 className='pull-left'>My account</h2>
      </div>
      <div id='my-profile' className='box-form-siteone clearfix'>
        <div className='col-md-2 text-center'>
          <img className='img-circle s1-avatar' src={AppSettings.DEFAULT_AVATAR} />
        </div>
        <div className='col-md-10'>
          <div className='form-group row'>
            <div className='col-sm-6 col-lg-4 my-profile-block'>
              <label className='col-sm-12' style={{paddingLeft: 0}}>First name <span className='text-danger'>*</span></label>
              <InputEditAble
                defaultValue={this.state.firstName}
                inputName='firstName'
                onSubmit={this.onSubmit}
              />

            </div>
          </div>

          <div className='form-group row'>
            <div className='col-sm-6 col-lg-4 my-profile-block'>
              <label className='col-sm-12' style={{paddingLeft: 0}}>Last name <span className='text-danger'>*</span></label>
              <InputEditAble
                defaultValue={this.state.lastName}
                inputName='lastName'
                onSubmit={this.onSubmit}
              />
            </div>
          </div>

          <div className='form-group row'>
            <div className='col-sm-6 col-lg-4 my-profile-block'>
              <label className='col-sm-12' style={{paddingLeft: 0}}>Phone number</label>
              <PhoneNumberInput
                ref={ref => { this.phoneNumber = ref; }}
                name='phoneNumber'
                defaultValue={this.state.phoneNumber}
                editAble
                onSubmit={this.onSubmit} />
              {/*<InputEditAble
                defaultValue={this.state.phoneNumber}
                inputName='phoneNumber'
                onSubmit={this.onSubmit}
                placeholder='(xxx)xxx-xxxx'
              ignoreRequired
              />*/}
            </div>
          </div>

          <div className='form-group row'>
            <div className='col-sm-6 col-lg-4 my-profile-block'>
              <label className='col-sm-12' style={{paddingLeft: 0}}>Daytime phone number</label>
              <PhoneNumberInput
                ref={ref => { this.daytimePhoneNumber = ref; }}
                name='daytimePhoneNumber'
                defaultValue={this.state.daytimePhoneNumber}
                editAble
                onSubmit={this.onSubmit} />
              {/*<InputEditAble
                defaultValue={this.state.daytimePhoneNumber}
                inputName='daytimePhoneNumber'
                onSubmit={this.onSubmit}
                placeholder='(xxx)xxx-xxxx'
                ignoreRequired
              />*/}
            </div>
          </div>

          {AppSettings.clientTypeValue === 'Homeowner'
            ? (
              <div className='form-group row'>
                <div className='col-sm-6 col-lg-4 my-profile-block'>
                  <label className='col-sm-12' style={{paddingLeft: 0}}>Email address <span className='text-danger'>*</span></label>
                  <InputEditAble
                    defaultValue={this.state.email}
                    inputName='email'
                    onSubmit={this.onSubmit}
                    placeholder='Your email address'
                    maxLength='256'
                    ignoreRequired
                    validEmail
                    errorMsg={this.state.errorEmail}
                  />
                </div>
              </div>
            )
            : (
              <div className='form-group row'>
                <div className='col-sm-8'>
                  <label className='col-sm-3' style={{paddingLeft: 0}}>Email address</label>
                  <label className='col-sm-9' style={{fontWeight: 600}}>{this.props.UserProfile.email}</label>
                </div>
              </div>
            )
          }

          <div className='form-group row'>
            <div className='col-sm-4'>
              <div style={{borderBottom: '1px solid #ccc'}} />
            </div>
          </div>

          <div className='form-group row'>
            <div className='col-sm-4'>
              <a onClick={this.toggleModal}
                className='s1-change-password'>Change password</a>
            </div>
          </div>
        </div>
      </div>

      {
        this.state.isOpenModal &&
        <ChangePasswordModal
          isOpen={this.state.isOpenModal}
          errorMsg={this.props.ErrorMsg}
          onChangePassword={this.onChangePasword}
          closeModal={this.toggleModal}
        />
      }

    </div>)
  }
}
const mapStateToProps = (state) => {
  return state.UserStore;
};

export default connect(mapStateToProps)(MyProfile);



// WEBPACK FOOTER //
// ./src/User/Containers/my-profile.js